// extracted by mini-css-extract-plugin
export default {"job_post_item_container":"job-post-item_job_post_item_container__cXgKM"};